'use client';

import classnames from 'classnames/bind';
import { ClientCategoryNodeWrapper } from '@/components/server-category-tree/_components/server-category-tree-display/_components/client-category-node-wrapper'; // Импортируем новую обертку
import {
  TMaterialsTreeCategoryItem,
  TMaterialsTreeItem,
} from '@/api/get-materials-tree/_types';
import { ServerCategorySectionButton } from './_components/server-category-section-button';
import styles from './index.module.scss';

const BLOCK_NAME = 'Category-item';
const cn = classnames.bind(styles);

type TProps = {
  category: TMaterialsTreeItem;
  childList: Array<TMaterialsTreeCategoryItem> | undefined;
  parentDict: Record<string, string>;
};

export const ServerCategoryItem = ({
  category,
  childList,
  parentDict,
}: TProps) => {
  if (!category) {
    return null;
  }

  const hasChildren = childList && childList.length > 0;

  const childrenContent = hasChildren ? (
    <div className={cn(`${BLOCK_NAME}__child`)}>
      {childList.map((item) => (
        <ServerCategorySectionButton
          key={item.id}
          category={item}
          parentCategoryTitle={category.title}
          parentDict={parentDict}
        />
      ))}
    </div>
  ) : null;

  return (
    <div className={cn(BLOCK_NAME)}>
      <ClientCategoryNodeWrapper
        category={category}
        elementType="category"
        isExpandable={hasChildren}
        parentDict={parentDict}
      >
        {childrenContent}
      </ClientCategoryNodeWrapper>
    </div>
  );
};
